import styled from 'styled-components'
import Text from './Text'

const TooltipText = styled(Text)`
  text-decoration: underline dotted #f4eeff;
  text-underline-offset: 0.1em;
`

export default TooltipText
